<template>
  <div class="form-dossier">
    <div class="row" v-if="dataForm.dossier.numNeph == ''">
      <div
        class="field col-md-7 col-xs-10 mt-4"
      >
        <select
          :value="dataForm.dossier.nationaliteFR"
          @change="handleChangeNationaliteFR($event.target.value)"
          id="nationaliteFR"
          name="nationaliteFR"
          class="form-select inputsize"
          :class="{ isNotValid: !checkNationaliteFR }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>Nationalité française</option>
          <option value="true">OUI</option>
          <option value="false">NON</option>
        </select>

        <label class="labelForm">Nationalité française</label>
      </div>

      <div class="field col-md-5 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.paysNaissance"
          @change="handleChangePaysNaissance($event.target.value)"
          type="text"
          id="paysNaissance"
          name="paysNaissance"
          class="form-control marge"
          :class="{ isNotValid: !checkPaysNaissance }"
          placeholder=" "
          :disabled=false
        />
        <label class="labelForm">Pays de naissance</label>
      </div>

      <div
        class="field col-md-6 col-sm-12 mt-4"
      >
        <input
          :value="dataForm.dossier.villeNaissance"
          @change="handleChangeVilleNaissance($event.target.value)"
          type="text"
          id="villeNaissance"
          name="villeNaissance"
          class="form-control inputsize"
          :class="{ isNotValid: !checkVilleNaissance }"
          placeholder=" "
          :disabled=false
        />
        <label class="labelForm">Ville de naissance</label>
      </div>

      <div class="field col-md-6 col-sm-12 mt-4">
        <input
          :value="dataForm.dossier.depNaissance"
          @change="handleChangeDepNaissance($event.target.value)"
          type="text"
          id="depNaissance"
          name="depNaissance"
          class="form-control inputsize"
          :class="{ isNotValid: !checkDepNaissance }"
          placeholder=" "
          :disabled=false
        />
        <label class="labelForm">Département de naissance</label>
        <span class="label-hint">Si né à l'étranger, indiquer 99</span>
      </div>
    </div>

    <div class="row">
      <div
        class="field col-md-6 col-xs-10 mt-4"
      >
        <select
          :value="dataForm.dossier.parlerFRCouramment"
          @change="handleChangeParlerFRCouramment($event.target.value)"
          id="parlerFRCouramment"
          name="parlerFRCouramment"
          class="form-select inputsize"
          :class="{ isNotValid: !checkParlerFRCouramment }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>Parlez-vous français ?</option>
          <option value="true">OUI</option>
          <option value="false">NON</option>
        </select>

        <label class="labelForm">Parlez-vous français</label>
      </div>

      <div class="field col-md-6 col-xs-10 mt-4">
        <select
          :value="dataForm.dossier.permis"
          @change="handleChangePermis($event.target.value)"
          id="permis"
          name="permis"
          class="form-select inputsize marge"
          :class="{ isNotValid: !checkPermis }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>Permis demandé ?</option>
          <option value="/api/permis/3">B</option>
        </select>

        <label class="labelForm">Permis demandé ?</label>
      </div>
    </div>

    <div class="row">
      <div class="field col-md-6 col-xs-10 mt-4">
        <select
          :value="dataForm.dossier.vehiculeAmenage"
          @change="handleChangeVehiculeAmenage($event.target.value)"
          id="vehiculeAmenage"
          name="vehiculeAmenage"
          class="form-select inputsize"
          :class="{ isNotValid: !checkVehiculeAmenage }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>
            Avez-vous un handicap ou une affection ?
          </option>
          <option value="true">OUI</option>
          <option value="false">NON</option>
        </select>

        <label class="labelForm"
          >Avez-vous un handicap ou une affection ?</label
        >
      </div>

      <div class="field  col-md-6 col-xs-10 mt-4">
        <select
          :value="dataForm.dossier.lunettes"
          @change="handleChangeLunettes($event.target.value)"
          id="lunettes"
          name="lunettes"
          class="form-select inputsize"
          :class="{ isNotValid: !checkLunettes }"
          placeholder=" "
          :disabled=false  
        >
          <option value="true">OUI</option>
          <option value="false">NON</option>
        </select>

        <label class="labelForm">Portez-vous des lunettes ?</label>
      </div>
    </div>

    <div
      class="field col-md-~2 col-xs-10 mt-4"
    >
      <select
        :value="dataForm.dossier.faitSuite"
        @change="handleChangeFaitSuite($event.target.value)"
        id="faitSuite"
        name="faitSuite"
        class="form-select inputsize"
        :class="{ isNotValid: !checkFaitSuite }"
        placeholder=" "
        :disabled=false
      >
        <option value="null" disabled>
          Votre permis a-t-il été annulé ou invalidé ?
        </option>
        <option value="true">OUI</option>
        <option value="false">NON</option>
      </select>

      <label class="labelForm"
        >Votre permis a-t-il été annulé ou invalidé ?</label
      >
    </div>

    <div
      v-if="dataForm.dossier.faitSuite == 'true'"
      class="field col-md-~2 col-xs-10 mt-4"
    >
      <select
        :value="dataForm.dossier.motifAlcoolStup"
        @change="handleChangeMotifAlcoolStup($event.target.value)"
        id="motifAlcoolStup"
        name="motifAlcoolStup"
        class="form-select inputsize"
        :class="{ isNotValid: !checkMotifAlcoolStup }"
        placeholder=" "
        :disabled=false
      >
        <option value="null" disabled>
          En raison d'une conduite sous alcoolémie ou stupéfiant ?
        </option>
        <option value="true">OUI</option>
        <option value="false">NON</option>
      </select>

      <label class="labelForm"
        >En raison d'une conduite sous alcoolémie ou stupéfiant ?</label
      >
    </div>

    <div class="row">
      <div class="field col-md-6 col-xs-10 mt-4">
        <select
          :value="dataForm.dossier.prevoitAac"
          @change="handleChangePrevoitAac($event.target.value)"
          id="prevoitAac"
          name="prevoitAac"
          class="form-select inputsize"
          :class="{ isNotValid: !checkPrevoitAac }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>Prévoyez-vous une conduite accompagnée ?</option>
          <option value="true">OUI</option>
          <option value="false">NON</option>
        </select>

        <label class="labelForm"
          >Prévoyez-vous une conduite accompagnée ?</label
        >
      </div>

      <div class="field col-md-6 col-xs-10 mt-4">
        <select
          :value="dataForm.dossier.social"
          @change="handleChangeSocial($event.target.value)"
          id="social"
          name="social"
          class="form-select inputsize"
          :class="{ isNotValid: !checkSocial }"
          placeholder=" "
          :disabled=false
        >
        <!--
          <option value="/api/statut_socials/1" data-v-9718538e="">Etudiant</option>
          <option value="/api/statut_socials/2" data-v-9718538e="">Lycéen</option>
          <option value="/api/statut_socials/3" data-v-9718538e="">Salarié</option>
          <option value="/api/statut_socials/4" data-v-9718538e="">Sans emploi</option>
          -->
          <option
            v-for="(item, index) in statutSocial"
            :value="'/api/statut_socials/' + item.id"
            :key="index"
          >
            {{ item.label }}
          </option>
        </select>

        <label class="labelForm">Statut social</label>
      </div>

      <div
        class="field col-md-6 col-xs-10 mt-4"
        :class="{ isHide: !isLyceen }"
      >
        <select
          :value="dataForm.dossier.lycee"
          @change="handleChangeLycee($event.target.value)"
          id="lycee"
          name="lycee"
          class="form-select inputsize"
          :class="{ isNotValid: !checkLycee }"
          placeholder=" "
          :disabled=false
        >
          <option value="null" disabled>Lycée</option>
          <option value="autre">Autre</option>
          <option
            v-for="(item, index) in lycees"
            :value="'/api/lycees/' + item.id"
            :key="index"
          >
            {{ item.nom }}
          </option>
        </select>

        <label class="labelForm">Lycée</label>
      </div>

      <div
        v-if="dataForm.dossier.lycee === 'autre'"
        class="field col-md-4 col-sm-12 mt-4"
        :class="{ isHide: !isAutreLycee }"
      >
        <input
          :value="dataForm.dossier.autreLycee"
          @change="handleChangeAutreLycee($event.target.value)"
          type="text"
          id="autreLycee"
          name="autreLycee"
          class="form-control inputsize"
          :class="{ isNotValid: !checkAutreLycee }"
          placeholder=" "
          :disabled=false
        />
        <label class="labelForm">Autre Lycée</label>
      </div>
    </div>

  </div>
    <div class="footer-form">
      <div><p v-if="error" class="errorMsg">{{ error }}</p></div>
      <div class="btnForm">
          <b-button
            @click="cancelStep"
            class="btnForm"
          >
            Retour
          </b-button>

          <b-button
            @click="suivantEtape2"
            class="btnForm"
          >
            Suivant
          </b-button>
      </div>
    </div>
</template>

<script>
export default {
  name: "FormulairesStep2",
  props: {
    step: Number,
    dataForm: Object,
    desac: Boolean,
    error: String,
    statutSocial: Array,
    lycees: Array,
    isLyceen: Boolean,
    isAutreLycee: Boolean,
    checkParlerFRCouramment: Boolean,
    checkPermis: Boolean,
    checkVehiculeAmenage: Boolean,
    checkPrevoitAac: Boolean,
    checkMotifAlcoolStup: Boolean,
    checkFaitSuite: Boolean,
    checkLunettes: Boolean,
    checkSocial: Boolean,
    checkNationaliteFR: Boolean,
    checkPaysNaissance: Boolean,
    checkVilleNaissance: Boolean,
    checkDepNaissance: Boolean,
    checkLycee: Boolean,
    checkAutreLycee: Boolean,
    handleChangeNationaliteFR: Function,
    handleChangePaysNaissance: Function,
    handleChangeVilleNaissance: Function,
    handleChangeDepNaissance: Function,
    handleChangeParlerFRCouramment: Function,
    handleChangePermis: Function,
    handleChangeVehiculeAmenage: Function,
    handleChangeLunettes: Function,
    handleChangeFaitSuite: Function,
    handleChangeMotifAlcoolStup: Function,
    handleChangePrevoitAac: Function,
    handleChangeSocial: Function,
    handleChangeLycee: Function,
    handleChangeAutreLycee: Function,
    suivantEtape2: Function,
    cancelStep: Function,
  },

  mounted() {
    console.log("les status : ", this.statutSocial)
  },

};
</script>

<style scoped>
.field {
  position: relative;
}

.labelForm {
  position: absolute;
  pointer-events: none;
  left: 1.25rem;
  top: 7.75px;
  transition: 0.2s ease all;
  font-size: 15px;
}

.field > input:focus ~ label,
input:not(:placeholder-shown) ~ label,
.field > select:focus ~ label,
select:not(:placeholder-shown) ~ label {
  top: -15px;
  font-size: 12px;
  line-height: black;
  overflow: hidden;
}


.title {
  font-size: 32px;
}

.isNotValid {
  border-color: red;
}

.isHide {
  display: none;
}

div.btnForm {
  display: flex;
  justify-content: space-between;
}

.label-hint {
  font-size: 0.78rem;
  color: #888;
  font-style: italic;
}
</style>
